import { ApiButton, Box, Button, Typography } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { MutationStatus } from 'react-query';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<{ isPhotoRejected: boolean }>()((theme, {isPhotoRejected}) =>
({
  buttonContainer: {
    marginTop: (isPhotoRejected ? '' : theme.spacing(6)),
    marginBottom: theme.spacing(15),
  },
  actionButton: {
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(0),
    },
  },
  errString: {
    color: theme.color.state.stateError,
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(2),
  },
}));

interface NonNationalUploadButtonsProps {
  isPhotoRejected: boolean;
  isFileRejected: boolean;
  apiButtonStatus: MutationStatus;
  isDisableApiButton: boolean;
  photoRejectedErrorMessage: string;
  fileRejectedErrorMessage: string;
  handleConfirmUpload: () => void;
  lockedByUser?: string;
  buttonCancelText?: string;
  buttonSubmitText?: string;
  isOpsAdmin?: boolean;
  timeoutRejectedErrorMessage: string;
}

const disabledButton = (isDisableApiButton: boolean, isOpsAdmin: boolean, isFileRejected: boolean) => {
  if (isFileRejected) {
    return true;
  }
  if (isOpsAdmin) {
    return false;
  }
  return isDisableApiButton;
};

const NonNationalUploadButtons = ({
  isPhotoRejected,
  isFileRejected,
  apiButtonStatus,
  isDisableApiButton,
  photoRejectedErrorMessage,
  fileRejectedErrorMessage,
  handleConfirmUpload,
  lockedByUser,
  buttonCancelText,
  buttonSubmitText,
  isOpsAdmin = false,
  timeoutRejectedErrorMessage,
}: NonNationalUploadButtonsProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { classes } = useStyles({ isPhotoRejected });
  const navigateBack = () => {
    history.goBack();
  };

  return (
    <>
      {isPhotoRejected && (
        <Typography variant="body2" className={classes.errString}>
          {photoRejectedErrorMessage}
        </Typography>
      )}
      {isFileRejected && (
         <Typography variant="body2" className={classes.errString}>
            {fileRejectedErrorMessage}
         </Typography>
      )}
      {timeoutRejectedErrorMessage && (
        <Typography variant="body2" className={classes.errString}>
          {timeoutRejectedErrorMessage}
        </Typography>
      )}
      <Box className={classes.buttonContainer}>
        {lockedByUser && (
          <Typography variant="body2" className={classes.errString}>
            {t('exam->>NonNationalExam.LockedMessage', { lockedByUser })}
          </Typography>
        )}
        <Button
          type="button"
          variant="outlined"
          size="medium"
          color="secondary"
          id="button-cancel"
          onClick={navigateBack}
        >
          {buttonCancelText || t('exam->>UploadDocument.Back')}
        </Button>
        <ApiButton
          className={classes.actionButton}
          status={apiButtonStatus}
          type="button"
          color="secondary"
          size="medium"
          disabled={disabledButton(isDisableApiButton, isOpsAdmin, isFileRejected)}
          onClick={handleConfirmUpload}
          id="button-proceed"
        >
          {buttonSubmitText || t('exam->>UploadDocument.ProceedToConfirmParticulars')}
        </ApiButton>
      </Box>
    </>
  );
};

export default NonNationalUploadButtons;
